import { Loader2 } from "lucide-react";

export const Loader = () => {
  return (
    <div className="col-span-full">
      <div className=" flex flex-col justify-center items-center py-20 space-y-3">
        <Loader2 className="w-8 h-8 animate-spin text-main" />
        <span className="ml-3 text-gray-600 text-sm">
          Chargement des données...
        </span>
      </div>
    </div>
  );
};
